import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

import { selectedAddressModel } from 'src/app/core/models/selectedAddress.interface';
import { environment } from '@environments/environment';
import Resources from '@constants/resourses';

import { RestapiService } from '@services/restapi.service';
import { SessionService } from '@services/session.service';
import { UtilityService } from '@services/utility.service';
@Component({
  selector: 'app-messagepopup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MarkdownModule],
  templateUrl: './messagepopup.component.html',
  styleUrls: ['./messagepopup.component.scss']
})
export class MessagepopupComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;

  subscriptions: Subscription[] = [];
  contentTitle: string;
  contentText: string;

  isLoggedIn: boolean = false;

  isNonDomestic: boolean = false;
  isPostcodeNotSupported: boolean = false;

  fuelType: string;
  postcode: string;
  correlationId: string;
  savedDetails: any;
  selectedAddress: selectedAddressModel;

  // Not in use
  newAddressToken: any;
  isSwitchpending: boolean = false;
  filterUIData: any;
  isCancelSwitch: boolean;
  currentUsage: any;
  isCampaignTrue: boolean;
  isSwitchPageInProgressSwitch: boolean;
  isQuotesPageInProgressSwitch: boolean;
  saveCorrelationIdWithAddress = [];

  signIn = () => {
    this.dialogRef.close();
    this.utilityService.signIn();
  }

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private restAPI: RestapiService,
    private router: Router,
    private sessionService: SessionService,
    private utilityService: UtilityService
  ) {
    this.postcode = this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Postcode) || '';
    this.correlationId = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.CorrelationId);
    this.savedDetails = this.sessionService.getData(Resources.SessionStorageKeys.SavedDetail);
    this.selectedAddress = this.sessionService.getData(Resources.SessionStorageKeys.SelectedAddress);

    this.fuelType = this.currentUsage?.electricity && this.currentUsage?.gas ? Resources.EnergyType.BOTH : (this.currentUsage?.electricity) ? Resources.EnergyType.ELECTRICITY : Resources.EnergyType.GAS;

    this.isLoggedIn = this.utilityService.isLoggedIn();
  }

  ngOnInit(): void {
    // Not a UK postcode
    if (this.data?.key === 'other/other-postCodeNotSupported.md') {
      this.isPostcodeNotSupported = true;
    } else if (this.data?.key === 'other/other-businessPostCodeNotSupported.md') {
      // Not a domestic postcode
      this.isNonDomestic = true;
    } else if (this.data?.key === 'dashboard/dashboard-content-IsSwitchInProgress.md') {
      this.isSwitchpending = true;
    } else if (this.data?.key === 'dashboard/dashboard-cancelSwitch.md') {
      this.isCancelSwitch = true;
    } else if (this.data?.key === 'switchingSupplier/SS-application-Form-NotEligibleForCampaign.md') {
      this.isCampaignTrue = true;
    } else if (this.data?.key === 'quotesPage/quotePage-switchInProgress.md' || this.data?.key === 'quotesPage/quotePage-switchInProgress-withdifferentEmail.md') {
      this.isQuotesPageInProgressSwitch = true;
    } else if (this.data?.key === 'switchingSupplier/SS-application-Form-switchInProgress.md' || this.data?.key === 'switchingSupplier/SS-application-Form-switchInProgress-withdifferentEmail.md') {
      this.isSwitchPageInProgressSwitch = true;
    } else {
      this.isSwitchpending = false;
      this.isCancelSwitch = false;
      this.isCampaignTrue = false;
    }

    // Add new address flow
    if (this.activatedRoute.snapshot.queryParams.userData) {
      this.newAddressToken = this.activatedRoute.snapshot.queryParams.userData;
    }

    // Get markdown file
    this.utilityService.getMDFile(this.data?.key).subscribe(data => {
      // Split by double new line
      let splitData: any[] = data.split('\n\n');

      // Get the title of modal
      this.contentTitle = splitData[0];

      // Shift method to pop content from top
      splitData?.shift();

      // Rest of the content is join with new line
      this.contentText = splitData.join('\n\n');
      this.isLoading = false;
    });
  }

  // Interim tariff detail sections (one per fuel present) built from the svtFallbackTariff passed through the dialog data
  get interimTariffSections(): { fuelLabel?: string; rows: { label: string; value: string }[] }[] {
    return this.utilityService.buildInterimTariffSections(this.data?.svtFallbackTariff, !!this.data?.hasElectricity, !!this.data?.hasGas);
  }

  // [TODO] Get user filter preference [Refactor this function][Not in use]
  getFilterPreference(): void {
    const evTariffFilter = {
      "Id": 161,
      "FilterType": "EVTariff",
      "FilterValue": [
        {
          "Id": 278,
          "Value": "0",
          "isDefault": false,
          "DisplayText": "EV tariff"
        },

      ],
      "DisplayHeading": "Electric vehicle",
      "UIType": "CheckBox"
    }
    const cPath = `/v1/plans/filters/userpreferences?correlationId=${this.correlationId}&fuelType=${this.fuelType}`;
    this.subscriptions.push(
      this.restAPI.getAPI(cPath).subscribe((data) => {
        this.filterUIData = data;
        const ACQFilter = data?.getACQFilterResponse?.length ? [...data.getACQFilterResponse] : [];
        ACQFilter.splice(3, 0, evTariffFilter)
        // Removing sessionvalues when user navigate backs to information page from quotes page
        this.sessionService.removeData(Resources.SessionStorageKeys.fdo);
        this.sessionService.removeData(Resources.SessionStorageKeys.ChangedFilterdata);
        this.sessionService.removeData(Resources.SessionStorageKeys.QuotesData);
        this.sessionService.removeData(Resources.SessionStorageKeys.AllQuotes);
        this.sessionService.removeData(Resources.SessionStorageKeys.QuotesEnergyType)
        this.sessionService.removeItemFromSession(Resources.SessionStorageKeys.QuotesID);
        this.sessionService.removeData(Resources.SessionStorageKeys.OptionSelect);
        this.sessionService.setData(Resources.SessionStorageKeys.PreferenceData, ACQFilter);
        this.sessionService.removeItemFromSession(Resources.SessionStorageKeys.IsBackFromQuotes);
        this.dialogRef.close();
        // Navigate to energy result page
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.router.navigate(['/energy-result'], { queryParams: queryParams });
      }, (err) => {
        console.log('ERROR: ', err);
      })
    );
  }
  // Navigate to energy result page
  navigateToEnergyResult(): void {
    // removed quotes data from session and local storage
    this.sessionService.removeData(Resources.SessionStorageKeys.QuotesData);
    this.sessionService.removeData(Resources.SessionStorageKeys.AllQuotes);

    // Navigate to energy result page
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.router.navigate(['/energy-result'], { queryParams: queryParams });

    this.dialogRef.close();
  }

  returnToResult() {
    // Removing the all quotes and Quoteid from session when user click return to result page
    this.sessionService.removeData(Resources.SessionStorageKeys.AllQuotes);
    this.sessionService.removeData(Resources.SessionStorageKeys.QuotesID);
    this.sessionService.removeData(Resources.SessionStorageKeys.QuotesData);
    
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.router.navigate(['/energy-result'], { queryParams: queryParams });
    this.dialogRef.close();
  }

  // Continue to Supplier - switch cancel
  switchCancelAPI(): void {
    const payload = {
      correlationId: this.correlationId,
      priceId: this.savedDetails?.switchDetails?.priceData?.priceId,
      quoteId: this.savedDetails?.switchDetails?.priceData?.quoteId,
    };

    this.subscriptions.push(
      this.restAPI.postAPI('/v3/supplier/supplierConfig', payload).subscribe({
        next: (res) => {
          if (res?.code === 200) {
            const switchingDashboard = res?.data?.SwitchDashboard;
            if (switchingDashboard?.cancelUrl) {
              window.open(res?.data?.SwitchDashboard?.cancelUrl, '_blank');
            } else {
              window.open('https://' + this.savedDetails?.switchDetails?.supplierData?.gocoHomePageURL, '_blank');
            }
          }
        }, error: (err) => {
          console.log('ERROR', err);
          window.open('https://' + this.savedDetails?.switchDetails?.supplierData?.gocoHomePageURL, '_blank');
        }
      })
    );
  }

  // Change Address button
  changeAddress(): void {
    this.dialogRef.close();
    this.sessionService.clearData();
    this.sessionService.clearSessionStorage();
    this.sessionService.removeData(Resources.SessionStorageKeys.QuotesData);
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.router.navigate(['/'], { queryParams: queryParams });
  }

  // Close Info Popup
  closeInfoPopup(): void {
    this.dialogRef.close(this.isSwitchpending ? 'close' : '');
  }

  takeMeToDashboard() {
    if (this.data?.key === 'dashboard/dashboard-content-IsSwitchInProgress.md' || this.data?.key === 'quotesPage/quotePage-switchInProgress.md' || this.data?.key === 'switchingSupplier/SS-application-Form-switchInProgress.md' || this.data?.key === 'switchingSupplier/SS-application-Form-switchInProgress-withdifferentEmail.md' || this.data?.key === 'quotesPage/quotePage-switchInProgress-withdifferentEmail.md') {
      // Navigate to the dashboard
      this.router.navigate(['/information'], { queryParams: this.activatedRoute.snapshot.queryParams });
    }

    this.dialogRef.close();
  }

  // Redirect to compare business energy
  // Business meter override new Ui figma 1 Mar 2024 | JIG 1292
  result(): void {
    // Tech Spec documents for Multi address, Business address and Smart meter | Added a tealium event when user Clicks on Yes, it's a business button | 29 Feb 2024 | JIG 1338
    window.open(`https://business-energy.comparethemarket.com/service-dom?postcode=${this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Postcode)}`, '_blank')

  }

  resultLink(): void {
    window.open(`https://business-energy.comparethemarket.com/service-dom?postcode=${this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Postcode)}`, '_blank')
  }

  // Not in use
  sameAddressIssue() {
    this.sessionService.clearSessionStorage();
    window.open(environment.home_url + '?userData=' + this.newAddressToken, '_self')
  }

  // Business meter override new Ui figma | 1 Mar 2024 | JIG 1292
  goToExceptionalFlow() {
    // Tech Spec documents for Multi address, Business address and Smart meter | Added a tealium event when user Clicks on No, it's a home button | 29 Feb 2024 | JIG 1338
    this.dialogRef.close({ data: 'itsHomeAddress' })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    })
  }
}
